module.exports = __webpack_public_path__ + "media/images/icons/youtube-beeff9a6703115cbd70d4db0a6e57b92.svg";